import React from "react";

export default function DashboardCoverIcon()
{
      return (
            <svg
                  width={32}
                  height={32}
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M16 2.66667C8.63999 2.66667 2.66666 8.64 2.66666 16C2.66666 23.36 8.63999 29.3333 16 29.3333C23.36 29.3333 29.3333 23.36 29.3333 16C29.3333 8.64 23.36 2.66667 16 2.66667ZM14.6667 26.5733C9.39999 25.92 5.33332 21.44 5.33332 16C5.33332 15.1733 5.43999 14.3867 5.61332 13.6133L12 20V21.3333C12 22.8 13.2 24 14.6667 24V26.5733ZM23.8667 23.1867C23.52 22.1067 22.5333 21.3333 21.3333 21.3333H20V17.3333C20 16.6 19.4 16 18.6667 16H10.6667V13.3333H13.3333C14.0667 13.3333 14.6667 12.7333 14.6667 12V9.33334H17.3333C18.8 9.33334 20 8.13334 20 6.66667V6.12001C23.9067 7.70667 26.6667 11.5333 26.6667 16C26.6667 18.7733 25.6 21.2933 23.8667 23.1867Z"
                        fill="#4CC2FF"
                  />
            </svg>



      );
}
